(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cencri-back-to-top"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.cencri-back-to-top');
  if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  // Themes may scroll an inner page wrapper instead of the document.
  for (let parent = link.parentElement; parent; parent = parent.parentElement) {
    if (parent.scrollHeight > parent.clientHeight) parent.scrollTo({ top: 0, behavior });
  }
  window.scrollTo({ top: 0, behavior });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-welcome-popup"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-welcome-popup]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('dialog');
      if (!dialog) return;

      const key = `lunaveil-welcome-popup-${root.id}`;
      const dismissDays = Number(root.dataset.dismissDays || 7);
      const delay = Number(root.dataset.delay || 8000);
      const isDesignMode = root.dataset.designMode === 'true';
      const hasSucceeded = Boolean(root.querySelector('[data-welcome-success]'));
      const hasError = Boolean(root.querySelector('[data-welcome-errors]'));
      const mobileDisabled = root.dataset.mobileEnabled !== 'true' && window.matchMedia('(max-width: 749px)').matches;
      let timer;
      let opened = false;

      const readState = () => {
        try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return {}; }
      };

      const writeState = (state) => {
        try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
      };

      const isSuppressed = () => {
        const state = readState();
        if (state.joined) return true;
        if (!state.dismissedAt) return false;
        return Date.now() - Number(state.dismissedAt) < dismissDays * 86400000;
      };

      const open = () => {
        if (opened || dialog.open || mobileDisabled) return;
        opened = true;
        dialog.showModal();
        window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        requestAnimationFrame(() => {
          const target = dialog.querySelector('[data-welcome-success], input, button');
          target?.focus({ preventScroll: true });
        });
      };

      const dismiss = () => {
        if (!hasSucceeded && !isDesignMode) writeState({ dismissedAt: Date.now() });
        dialog.close();
      };

      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.35) open();
      };

      root.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', dismiss));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && dialog.open) dismiss(); });

      root.querySelector('[data-welcome-copy]')?.addEventListener('click', async (event) => {
        const code = root.querySelector('[data-welcome-code]')?.textContent.trim();
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          event.currentTarget.textContent = 'Copied';
        } catch (_) {
          root.querySelector('[data-welcome-code]')?.focus();
        }
      });

      if (hasSucceeded) {
        writeState({ joined: true });
        open();
      } else if (hasError || isDesignMode) {
        open();
      } else if (!isSuppressed() && !mobileDisabled && !location.pathname.match(/^\/(cart|checkout|account)(\/|$)/)) {
        timer = window.setTimeout(open, delay);
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === root.id.replace('LvWelcomePopup-', '')) open();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-worn-together"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('soft-gleam-tryon'))customElements.define('soft-gleam-tryon',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('dialog');if(!dialog)return;let trigger;this.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{trigger=button;const img=dialog.querySelector('img');img.src=button.dataset.image;img.alt=button.querySelector('img').alt;dialog.showModal()}));dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>trigger?.focus());}
});

  } catch(e) { console.error(e); }
})();
})();
